import get from 'lodash.get';

import { emptyObject } from 'ui-components/default-props/empty';

const selectBatches = (state) => get(state, 'batches', emptyObject);
const selectBatchJobs = (state) => get(state, 'batchJobs', emptyObject);

export const selectBatchByFulfillmentPlanSetId = (state, props) => get(selectBatches(state, props), props.fulfillmentPlanSetId);
export const selectBatchJobByJobId = (state, props) => get(selectBatchJobs(state, props), props.jobId);
